import integrationAPIJSON from "./integrationApiEnv.json";

declare global {
  interface Window {
    env: any;
  }
}

// change with your own variables
type EnvType = {
  NODE_ENV: "development" | "staging" | "production";
  APP_VERSION: string;
};

type ItegrationAPIType = {
  [key in EnvType["NODE_ENV"]]: string;
};

export const env: EnvType = { ...process.env, ...window.env };

export const integrationAPI: ItegrationAPIType = integrationAPIJSON;
